module.exports = __webpack_public_path__ + "media/images/ioc-logo-shield-4ece6c128caa4bc294583b26207d41b4.png";